'use strict';

export default class ButtonSearch {
    constructor() {
        // $('.js-toggle-search').on('click', function ()  {
        //     let $this = $(this),
        //         $parent = $this.parent(),
        //         $next = $this.next();

        //     $parent.toggleClass('active');

        //     if ($parent.hasClass('active')) {
        //         $next.focus();
        //     }
        // });
    }
}
